import React from "react";
import useCreateModel from "../../customHooks/CreateModel/useCreateModel";
import { Dialog, DialogActions, DialogContentText } from "@material-ui/core";
import { DialogContent, DialogTitle } from "@mui/material";
import { Button, Modal } from "react-bootstrap";
import { AiFillAlert } from "react-icons/ai";
import { IoArrowBackCircle } from "react-icons/io5";
import { useParams } from "react-router";
import SmallLoader from "../../components/SmallLoader/SmallLoader";
import { Loader as LoaderIcon } from "react-feather";
import classes from "./CreateModel.module.css";
import { FaEdit } from "react-icons/fa";
import { RxReset } from "react-icons/rx";
import CompareCoordiantes from "../CompareCoordiantes/CompareCoordiantes";
import ImageMarkingTool from "../ImageMarkingTool/ImageMarkingTool";
import ImageMarkingTool1 from "../ImageMarkingTool/Image1";
const CreateModel = () => {
  const { id } = useParams();

  const talonProps = useCreateModel({ id });
  const {
    modelDetails,
    handleChange,
    handleAddImageTab,
    handleTabLabelChange,
    handleImageChange,
    imageJson,
    imageTabs,
    handleDelete,
    selectOptions,
    show,
    handleClose,
    createitemstatus,
    navigating,
    handleModelChange,
    apiLoader,
    handleBack,
    openImage,
    setOpenImage,
    imageError,
    handleEdit,
    isImageEditing,
    setIsImageEditing,
    isEditing,
    imageSrc,
    handleSubmit,
    imageLoader,
    errorMessage,
    confirmDelete,
    setConfirmDelete,
    deleteIndex,
    setDeleteIndex,
    handleBlur,
    renderErrorMessage,
    setImageJson,
    imageDetails,
    setImageDetails,
    newCoordinates,
    setNewCoordinates,
    openCoordinates,
    setOpenCoordinates,
    setSelectedModalId,
    coordinatesRef,
    handleEditClick,
    isEdit,
    setIsEdit,
    handleInputChange,
    handleChangeCoordinate,
    handleNeckInputChange,
    openImageMarking,
    setOpenImageMarking,
    selectedImage,
    setSelectedImage,
    isPythonCalled,
    getPythonCoordaintes,
  } = talonProps;
  let isButtonDisabled =
    !imageJson.sURL || !imageJson.sTone || !imageJson.iBodyTypeId;
  // console.log(imageJson.sURL || !imageJson.sTone || !imageJson.iBodyTypeId);

  const fileMemo = (
    <input
      type="file"
      id="imageInput"
      name="imageInput"
      accept="image/*"
      onChange={handleImageChange}
      disabled={!imageJson.sTone || !imageJson.iBodyTypeId}
      className="form-control border-black py-1.5 px-2.5"
    />
  );

  return (
    <>
      {/* <iframe
        title="FS TACKER VISUALIZATION"
        width="1140"
        height="541.25"
        src="https://app.powerbi.com/reportEmbed?reportId=66001cf7-7db8-43b2-a731-cd4cecba8a8f&autoAuth=true&embeddedDemo=true"
        frameborder="0"
        allowFullScreen="true"
      ></iframe> */}
      <div className="container mx-auto my-4">
        <div className="flex justify-between">
          <span
            className={`mb-2  p-1 text-[20px] font-700 border-b-[5px] border-solid border-[#646af5]`}
          >
            {!id ? "Create Model" : "Update Model"}
          </span>
          <button
            className={`flex items-center p-2 text-white  justify-center 
            h-full leading-none font-bold  ${classes.back}`}
            style={{ backgroundColor: "#646af5" }}
            onClick={handleBack}
          >
            <IoArrowBackCircle size={20} /> Back
          </button>
        </div>
        <div className="screenMainRoot p-3 my-3 middle_main_container">
          <div className="grid lg:grid-cols-4 gap-x-8 ">
            <div className="p-1 flex flex-col">
              <label className="form-label formLabels" htmlFor="modelName">
                Model Name <span className="red">*</span>
              </label>
              <input
                type="text"
                id="modelName"
                name="modelName"
                className="form-control border-black py-1.5 px-2.5"
                value={modelDetails.modelName}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <div className="text-left text-small  color_red inputErrorSection">
                {renderErrorMessage("modelName")}
              </div>
            </div>
            {id && (
              <div className="p-1 flex flex-col">
                <label className="form-label formLabels" htmlFor="sCode">
                  Model Code <span className="red">*</span>
                </label>
                <input
                  type="text"
                  id="sCode"
                  name="sCode"
                  className="form-control  py-1.5 px-2.5"
                  value={modelDetails.sCode}
                  disabled
                />{" "}
              </div>
            )}
            <div className="p-1 flex flex-col">
              <label className="form-label formLabels" htmlFor="gender">
                Gender <span className="red">*</span>
              </label>
              <select
                className="form-select border border-black bg-white py-1.5 px-2.5"
                name="gender"
                id="gender"
                value={modelDetails?.gender}
                onChange={handleChange}
                onBlur={handleBlur}
              >
                <option value={""}>Select Option</option>
                {selectOptions.genderOptions.map((gender) => {
                  return (
                    <option value={gender.iGenderId} key={gender.iGenderId}>
                      {gender.sName}
                    </option>
                  );
                })}
              </select>
              <div className="text-left text-small  color_red inputErrorSection">
                {renderErrorMessage("gender")}
              </div>
            </div>
            <div className="p-1 flex flex-col">
              <label className="form-label formLabels" htmlFor="sType">
                Model Type <span className="red">*</span>
              </label>
              <select
                className="form-select border border-black bg-white py-1.5 px-2.5"
                name="sType"
                id="sType"
                value={modelDetails?.sType}
                onChange={handleChange}
                onBlur={handleBlur}
              >
                <option>Select Option</option>
                <option value={"portrait"}>Portrait</option>
                <option value={"landscape"}>Landscape</option>
              </select>
              <div className="text-left text-small  color_red inputErrorSection">
                {renderErrorMessage("sType")}
              </div>
            </div>
          </div>
          <div className="formBodyHeadings">Model Image</div>
          <div className="lg:grid grid-cols-4 gap-x-8">
            <div className="p-1 flex flex-col">
              <label className="form-label formLabels" htmlFor="modelName">
                Primary Image <span className="red">*</span>
              </label>

              {id && !isImageEditing ? (
                <div className="flex items-center gap-4">
                  <button
                    type="button"
                    onClick={() => setIsImageEditing(true)}
                    className={`py-1 px-3 text-white ${classes.edit}`}
                  >
                    Edit
                  </button>
                </div>
              ) : (
                <input
                  type="file"
                  accept="image/*"
                  id="modelImage"
                  name="modelImage"
                  className="form-control border-black py-1.5 px-2.5"
                  handleBlur={handleBlur}
                  onChange={handleModelChange}
                />
              )}
              <div className="text-left text-small  color_red inputErrorSection">
                {renderErrorMessage("modelImage")}
              </div>
            </div>
            {imageSrc && (
              <img
                src={imageSrc}
                alt="Model"
                className="w-20 h-20 object-cover rounded-lg"
              />
            )}
          </div>

          <div className="formBodyHeadings flex">
            <div className="my-auto">Images</div>
            <div className="flex mr-6 my-1 justify-end w-full">
              <button
                onClick={() => {
                  setOpenImage(true);
                }}
                className={`text-[#131dfe] ${
                  !modelDetails.gender ? "bg-[#99c2eb]" : "bg-[#0069d9]"
                }  ${
                  classes.addname
                } px-4 py-2 font-semibold text-sm rounded-lg`}
                disabled={!modelDetails.gender}
              >
                Add Image
              </button>
            </div>
          </div>

          <div className="flex flex-col min-h-20 border-[1px]">
            <div className="">
              <table className="w-full border-collapse border border-gray-300 table-responsive-sm">
                <thead className="bg-gray-100">
                  <tr className="border-b-[1px]">
                    <th className="border border-gray-300 py-2 text-center">
                      Images
                    </th>
                    <th className="border border-gray-300 py-2 text-center">
                      Model Code
                    </th>
                    <th className="border border-gray-300 py-2 text-center">
                      Tag
                    </th>
                    <th className="border border-gray-300 py-2 text-center">
                      Skin Tone
                    </th>
                    <th className="border border-gray-300 py-2 text-center">
                      Actions
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {imageTabs.length > 0 ? (
                    imageTabs.map((item, index) => (
                      <tr key={index} className="border-b">
                        <td className="border border-gray-300 text-center p-2">
                          <img
                            src={item.sURL}
                            alt={item.tabLabel}
                            className="h-20 w-auto rounded-lg mx-auto"
                          />
                        </td>

                        <td className="border border-gray-300 text-center p-2">
                          {item?.sCode}
                        </td>

                        <td className="border border-gray-300 text-center p-2">
                          {item.sTagName || item.sTag}
                        </td>

                        <td className="border border-gray-300 text-center p-2">
                          {item.sTone}
                        </td>

                        <td className="border border-gray-300 text-center p-2">
                          <div className="flex justify-center items-center gap-4">
                            {!item?.iGalleryId && (
                              <button
                                onClick={() => {
                                  setConfirmDelete(true);
                                  setDeleteIndex(index);
                                }}
                                className="py-1 px-3 text-white bg-red-500 rounded-lg hover:bg-red-600 focus:ring-4 focus:ring-red-300"
                              >
                                Delete
                              </button>
                            )}
                            <button
                              onClick={() => handleEdit(index)}
                              className={`py-1 px-3 text-white rounded-lg ${classes.edit}`}
                            >
                              Edit
                            </button>
                            {/* <button
                              onClick={() => {
                                setOpenCoordinates(true);
                                setSelectedModalId(item.iGalleryId);
                                setImageDetails({
                                  ...item,
                                  iBodyTypeId: item.iBodyTypeId,
                                  sCoordinate: item.sCoordinate,
                                });
                                setNewCoordinates(JSON.parse(item.sCoordinate));
                              }}
                              className={`py-1 px-3 text-white rounded-lg ${classes.edit}`}
                            >
                              Compare
                            </button> */}
                            <button
                              onClick={() => {
                                setOpenImageMarking(true);
                                setSelectedImage(item);
                              }}
                              className={`py-1 px-3 text-white rounded-lg ${classes.edit}`}
                            >
                              Add Coordiantes
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="5"
                        className={`text-center py-4 ${
                          imageError
                            ? "bg-[#ffebeb] text-red-500"
                            : "bg-[#f2f2f2] text-gray-500"
                        }`}
                      >
                        {imageError ? "Add at least one image" : "Add image"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="my-4">
            {apiLoader ? (
              <button
                className="screenFormSubmitLoaderBtn consistentBtn"
                style={{ width: "100px" }}
                disabled={apiLoader}
              >
                <LoaderIcon size={20} className="indicator" />
              </button>
            ) : (
              <button
                type="submit"
                className="screenFormSubmitButton consistentBtn "
                disabled={apiLoader}
                onClick={handleSubmit}
              >
                {id ? "Update Model" : "Create Model"}
              </button>
            )}
          </div>
        </div>
      </div>

      <Dialog open={show} onClose={handleClose}>
        <DialogTitle className="newpopupstyle"></DialogTitle>
        <DialogContent>
          <DialogContentText>
            <AiFillAlert />
          </DialogContentText>
          <DialogContentText>{createitemstatus}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={navigating} color="success">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Modal
        show={openImage}
        onHide={() => {
          setOpenImage(false);
          setImageJson({
            iBodyTypeId: null,
            dToneValue: null,
            sTone: null,
            sTag: null,
            imageUrl: "",
            tabLabel: "",
            image: "",
          });
        }}
        size="lg"
        className="modal-main"
      >
        <Modal.Header closeButton>
          <Modal.Title className={`${classes.modalheader}`}>
            {" "}
            {isEditing ? "Edit Model Image" : "Add Model Image"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="grid lg:grid-cols-2">
            <form className="grid gap-x-8 mb-6">
              <div className="grid">
                <div className="p-1 flex flex-col">
                  <label className="form-label formLabels" htmlFor="bodyType">
                    BodyType <span className="red">*</span>
                  </label>
                  <select
                    className="form-select border border-black bg-white py-1.5 px-2.5"
                    name="bodyType"
                    id="bodyType"
                    value={imageJson?.iBodyTypeId}
                    onChange={(e) => handleTabLabelChange(e, "iBodyTypeId")}
                  >
                    <option value="">Select Option</option>
                    {selectOptions.bodyTypeOptions.map((bodyType) => {
                      return (
                        <option
                          value={bodyType.iBodyTypeId}
                          key={bodyType.iBodyTypeId}
                        >
                          {bodyType.sName}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="grid lg:grid-cols-2">
                <div className="p-1 flex flex-col">
                  <label className="form-label formLabels" htmlFor="tagLabel">
                    Skin Tone <span className="text-red-500">*</span>
                  </label>

                  <select
                    className="form-select border border-black bg-white py-1.5 px-2.5"
                    name="sTone"
                    id="sTone"
                    value={imageJson.sTone || imageJson.sTone}
                    onChange={(e) => handleTabLabelChange(e, "sTone")}
                  >
                    <option value="">Select Option</option>
                    <option value={"light"}>Light</option>
                    <option value={"dark"}>Dark</option>
                  </select>
                </div>
                <div className="p-1 flex flex-col">
                  <label className="form-label formLabels" htmlFor="tagLabel">
                    Skin Tone Value<span className="text-red-500">*</span>
                  </label>

                  <input
                    className="form-select border border-black bg-white py-1.5 px-2.5"
                    name="dToneValue"
                    id="dToneValue"
                    type="text"
                    value={imageJson?.dToneValue}
                    disabled={imageJson?.sTone === "light"}
                    onChange={(e) => handleTabLabelChange(e, "dToneValue")}
                  />
                </div>
                <div className="p-1 flex flex-col">
                  <label className="form-label formLabels" htmlFor="tagLabel">
                    Tag Name <span className="text-red-500">*</span>
                  </label>

                  <input
                    type="text"
                    id="tagLabel"
                    name="tagLabel"
                    value={imageJson.sTagName}
                    //onChange={handleTabLabelChange}
                    className="form-control border-black py-1.5 px-2.5"
                    disabled
                  />
                </div>
              </div>
            </form>
            <div className="grid">
              <div>
                <div className="p-1 flex flex-col">
                  <label
                    className="form-label formLabels text-gray-700"
                    htmlFor="imageInput"
                  >
                    Choose Image <span className="text-red-500">*</span>
                  </label>
                  {fileMemo}
                </div>

                {!imageLoader ? (
                  <>
                    {imageJson.sURL ? (
                      <div className="flex justify-center my-4">
                        <img
                          src={imageJson.sURL}
                          className="w-40 h-40"
                          alt="Processed Image"
                        />
                      </div>
                    ) : (
                      errorMessage && (
                        <div className="text-red-500 text-center">
                          {errorMessage}
                        </div>
                      )
                    )}
                  </>
                ) : (
                  <div className="screenTableRootLoader">
                    <SmallLoader />
                  </div>
                )}
              </div>
              {imageJson?.sCoordinates && <>{}</>}
            </div>
            <div className="p-1 flex flex-col">
              <label className="invisible">Submit</label>
              <div>
                <button
                  type="submit"
                  className={`py-2 px-4 text-white ${
                    isButtonDisabled
                      ? classes.modalbtnDisabled
                      : classes.modalbtn
                  } rounded-lg `}
                  onClick={handleAddImageTab}
                  disabled={isButtonDisabled}
                >
                  {isEditing ? "Save Changes" : "Add"}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={confirmDelete}
        onHide={() => setConfirmDelete(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
          {/* <div className="flex justify-end w-100">
            <button onClick={() => handleDeleteClose(imageData.iGalleryId)}>
              <IoMdClose size={20} />
            </button>
          </div> */}
        </Modal.Header>
        <Modal.Body>
          <div className="flex flex-col gap-4 items-center">
            <span className="text-center">Do you want to delete the image</span>
            <button
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded text-center"
              onClick={() => handleDelete(deleteIndex)}
            >
              Delete
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={openCoordinates}
        onHide={() => {
          coordinatesRef.current = false;
          setOpenCoordinates(false);
          setIsEdit(false);
          setImageDetails({
            modelName: "",
            iBodyTypeId: null,
            iGenderId: null,
          });
          setSelectedModalId(null);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="lg"
        className="mainModal CoOrdinates"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Co-ordinates</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <CompareCoordiantes
            coordinatesRef={coordinatesRef}
            setNewCoordinates={setNewCoordinates}
            setIsEdit={setIsEdit}
            imageDetails={imageDetails}
            classes={classes}
            modelDetails={modelDetails}
            newCoordinates={newCoordinates}
            handleNeckInputChange={handleNeckInputChange}
            handleEditClick={handleEditClick}
            handleInputChange={handleInputChange}
            isEdit={isEdit}
          />
        </Modal.Body>
        <Modal.Footer>
          {coordinatesRef.current && (
            <>
              <button
                className="flex p-2 bg-gray-100 items-center justify-center text-blue-500 rounded-lg"
                onClick={async () => {
                  handleChangeCoordinate();
                  coordinatesRef.current = false;
                  setIsEdit(false);
                }}
              >
                Update Co-ordinates
              </button>
            </>
          )}
        </Modal.Footer>
      </Modal>
      <Modal
        show={openImageMarking}
        onHide={() => {
          setOpenImageMarking(false);
        }}
        fullscreen={true}
        className="coOrdianteModal"
      >
        <Modal.Header closeButton>Mark Image Coordiantes</Modal.Header>
        <Modal.Body>
          <ImageMarkingTool1
            iBodyTypeId={selectedImage.iBodyTypeId}
            imageUrl={selectedImage.sURL}
            isPythonCalled={isPythonCalled}
            getPythonCoordaintes={getPythonCoordaintes}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CreateModel;
